import styled from 'styled-components'
import { cardSurface } from '@components/Card'

/** The stream over its composer, on one card that fills what the heading leaves. */
export const ChatPanel = styled.div`
	${cardSurface}
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	padding: 0;
	overflow: hidden;
`
